import { LetterbookOrderOption } from "features/Letterbooks/types";

// General
export const shuffle = {
  title: "Shuffle",
  fieldname: "shuffle",
  direction: "asc",
  type: "symbol",
} as LetterbookOrderOption;

// books
export const bookTitle = {
  title: "Book Title",
  fieldname: "books_title",
  direction: "asc",
  type: "string",
} as LetterbookOrderOption;

export const bookPopularity = {
  title: "Book Popularity",
  fieldname: "books_users_count",
  direction: "desc",
  type: "number",
} as LetterbookOrderOption;

export const bookLength = {
  title: "Book Length",
  fieldname: "books_pages",
  direction: "asc",
  type: "number",
} as LetterbookOrderOption;

export const bookReleaseDate = {
  title: "Book Release Date",
  fieldname: "books_release_date",
  direction: "asc",
  type: "number",
} as LetterbookOrderOption;

export const bookRating = {
  title: "Book Avg Rating",
  fieldname: "books_rating",
  direction: "desc",
  type: "number",
} as LetterbookOrderOption;

// editions
export const editionPopularity = {
  title: "Edition Popularity",
  fieldname: "editions_users_count",
  direction: "desc",
  type: "number",
} as LetterbookOrderOption;

// user_books
export const yourRating = {
  title: "Your Rating",
  fieldname: "user_books_rating",
  direction: "desc",
  type: "number",
} as LetterbookOrderOption;

export const yourFirstDateRead = {
  title: "Your First Date Read",
  fieldname: "user_books_first_read_at",
  direction: "desc",
  type: "number",
} as LetterbookOrderOption;

export const yourLastDateRead = {
  title: "Your Last Read Date",
  fieldname: "user_books_last_read_at",
  direction: "desc",
  type: "number",
} as LetterbookOrderOption;

export const yourPercentage = {
  title: "Match Percentage",
  fieldname: "match",
  direction: "desc",
  type: "number",
  pro: true,
} as LetterbookOrderOption;

// Owner
export const ownerRating = {
  title: "Owner Rating",
  fieldname: "owner_rating",
  direction: "desc",
  type: "number",
} as LetterbookOrderOption;

export const ownerLastReadDate = {
  title: "Owner Last Read Date",
  fieldname: "owner_last_read_at",
  direction: "desc",
  type: "number",
} as LetterbookOrderOption;
